import React from "react";
import { Header } from "../components/Header";
import { HeroVariant } from "../components/HeroVariant";
import { AboutSection } from "../components/AboutSection";
import { SpeakersSection } from "../components/SpeakersSection";
import { ExperienceSection } from "../components/ExperienceSection";
import { EventFormatSection } from "../components/EventFormatSection";
import { ImpactSection } from "../components/ImpactSection";
import { SponsorsSection } from "../components/SponsorsSection";
import { Footer } from "../components/Footer";

export default function DesignB() {
  return (
    <div className="min-h-screen" style={{ background: "#ffffff", fontFamily: "'Inter', Arial, sans-serif" }}>
      <Header />
      <main>
        <HeroVariant bgImage="/group.jpg" darkOverlay={true} accentColor="#FE3A80" />
        <AboutSection />
        <SpeakersSection />
        <ExperienceSection />
        <EventFormatSection />
        <ImpactSection />
        <SponsorsSection />
      </main>
      <Footer />
    </div>
  );
}
